<mat-card appearance="outlined" class="header">
  <button mat-raised-button
          color="primary"
          (click)="goToCreate()">{{createButtonText}}</button>
</mat-card>
<div class="table-wrapper">
  <app-data-table *ngIf="apiUrl"
                  [apiUrl]="apiUrl"
                  [columnHeader]="columnHeader"
                  sortDirection=""
                  [pageSize]="10"
                  [pageSizeOptions]="[10, 50, 100]"
                  (rowClicked)="rowClicked($event)"></app-data-table>
</div>
